import { useEffect, useRef, useState } from "react";
import SubHeader from "../../../components/SubHeader";
import LocalStorageService from "../../../services/localStorageService";
import { useDispatch } from "react-redux";
import { login, setPlayerName, setPlayerUid, setServerName } from "../../../store/generalSlice";
import './Login.scss';
import MafiaService from "../../../services/mafiaService";
import { showErrorToast } from "../../../store/messageSlice";
import { setGameMode } from "../../../store/gameSlice";
import { GameModeEnum } from "../../../types/gameModeEnum";

function Login() {
    const dispatch = useDispatch();
    const [player, setPlayer] = useState('');
    const [server, setServer] = useState('');

    useEffect(() => {
        async function updateRef() {
            const cachePlayer = LocalStorageService.GetName();
            const cacheServer = LocalStorageService.GetServer();
            if (cachePlayer) {
                setPlayer(cachePlayer);
            }

            if (cacheServer) {
                setServer(cacheServer);
            }
        }
        updateRef();
    }, []);

    const setData = (): string => {           
        let guid = LocalStorageService.GetUid();
        if(!guid){
            guid = LocalStorageService.GenerateGuid();
        }
        LocalStorageService.SetName(player);
        LocalStorageService.SetServer(server);
        dispatch(setServerName(server));
        dispatch(setPlayerName(player));
        dispatch(setPlayerUid(guid));
        return guid;
    }

    const onJoin = () => {
        const guid = setData();
        join(guid);
    }

    const join = (guid: string) => {
        MafiaService.JoinGame(server, player, guid, (is_ok, payload) => {
            if(is_ok) {                
                dispatch(login());
                dispatch(setGameMode(GameModeEnum.Lobby));
            } else {
                dispatch(showErrorToast(payload || "Unknown Join Error"));
            }
        });
    }

    const onCreate = () => {
        const guid = setData();
        MafiaService.CreateGame(server, player, guid, (is_ok, message) => {
            if (is_ok) {
                join(guid);
            } else {
                dispatch(showErrorToast(message || "Unknown Create Error"));
            }
        });
    }

    const handleKeypress = (e: any) => {
      if (e.keyCode === 13) {
        onJoin();
      }
    };

    return <div className="mafia-container">
        <SubHeader>Login</SubHeader>
        <div className="mafia-login-container">

            <div className="mafia-form-label">Your Name</div>
            <input type="text" name="playerName" value={player} onChange={(e)=>setPlayer(e.target.value.trim())} onKeyDown={handleKeypress}></input>

            <div className="mafia-form-label">Server Name</div>
            <input type="text" name="gameName" value={server} onChange={(e)=>setServer(e.target.value.trim())} onKeyDown={handleKeypress}></input>

            <div className="mafia-form-buttons">
                <button type="submit" name="join-button" onClick={onJoin}>Join</button>
                <button type="submit" name="create-button" onClick={onCreate}>Create</button>
            </div>
        </div>
    </div>
}

export default Login;